import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TransitionNewComponent } from "./transition-new.component";

@NgModule({
	declarations: [
		TransitionNewComponent
	],
	imports: [CommonModule],
	exports: [
		TransitionNewComponent
	]
})
export class TransitionNewModule {}
